import { authGuard } from './auth/auth.guard';
import { configurationResolver } from './resolvers/configuration.resolver';
import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'login',
    resolve: { config: configurationResolver },
    loadComponent: () => import('./login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'home',
    canActivate: [authGuard],
    resolve: { config: configurationResolver },
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'custom-boards',
    canActivate: [authGuard],
    loadChildren: () => import('./custom-boards/custom-board.routes').then(m => m.customBoardRoutes),
  },
  {
    path: 'error',
    loadComponent: () => import('./error/error.component').then(m => m.ErrorComponent),
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  { path: '**', loadComponent: () => import('./home/home.page').then((m) => m.HomePage) },
  {
    path: 'schedule',
    loadComponent: () =>
      import('./custom-boards/schedule-page/court-schedule-page.component').then(
        (m) => m.CourtScheduleComponent
      ),
  }
];
